import { Controller, ActionEvent } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["activeCustomers", "newCustomers", "lapsedCustomers", "segmentSelect"]

  declare activeCustomersTarget: HTMLParagraphElement;
  declare newCustomersTarget: HTMLParagraphElement;
  declare lapsedCustomersTarget: HTMLParagraphElement;
  declare segmentSelectTarget: HTMLSelectElement;

  connect(): void {
    this.showCustomerSelectedChoice(this.segmentSelectTarget.value)
  }

  showChoice(event: ActionEvent): void {
    this.showCustomerSelectedChoice((event.currentTarget as HTMLSelectElement).value)
  }

  private showCustomerSelectedChoice(value: string) {
    const targetMap: Record<string, HTMLParagraphElement> = {
      active_customers: this.activeCustomersTarget,
      lapsed_customers: this.lapsedCustomersTarget,
      new_customers: this.newCustomersTarget,
    }

    Object.values(targetMap).forEach(t => t.classList.add("is-hidden"))

    if (targetMap[value]) {
      targetMap[value].classList.remove("is-hidden")
    }
  }
}
